import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'orange';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-purple-600 text-white hover:bg-brand-purple-700 shadow-sm hover:shadow-md focus-visible:ring-brand-purple-600',
    secondary: 'bg-brand-purple-100 text-brand-purple-900 hover:bg-brand-purple-200 focus-visible:ring-brand-purple-500',
    outline: 'border-2 border-brand-purple-600 bg-white text-brand-purple-700 hover:bg-brand-purple-50 focus-visible:ring-brand-purple-400',
    ghost: 'hover:bg-gray-100 text-gray-700 hover:text-gray-900',
    orange: 'bg-brand-orange-500 text-white hover:bg-brand-orange-600 shadow-sm hover:shadow-md focus-visible:ring-brand-orange-500'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-618">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-619" />}
      {children}
    </button>;
}